(function() {
  'use strict';
  angular.module('dso')
  .controller('dsoProviderUserController', ['$uibModal', 'DsoUsers', '$stateParams', '$state',
  '$scope','$timeout', 'gridServices', 'uiGridConstants', 'secSecurityService', 'Dso', '$filter', 'adminUsers',
  'dsoProviderService', function($uibModal, DsoUsers, $stateParams, $state, $scope, $timeout, gridServices, uiGridConstants,
    securityService, Dso, $filter, Users, dsoProviderService) {
      var vm = this;
      vm.user = _.clone($stateParams.user);
      vm.email = vm.user.unverifiedEmail ? vm.user.unverifiedEmail : vm.user.verifiedEmail;
      vm.model = {};
      vm.mode = $stateParams.mode;
      vm.dsoTaxIds = [];
      vm.approvedDsoTaxIds = [];
      vm.running = false;
      vm.showGrid = true;
      vm.close = close;
      vm.deleteProvider = deleteProvider;
      vm.submit = submit;
      vm.resendRegistrationInvite = resendRegistrationInvite;
      vm.providerDsoTaxIdLocations = [];            
      vm.emailResent = false;
      vm.previous = previous;
      vm.locationSvcUnavailable = false;

      securityService.hasAnyAuthority('PREVIOUS_ADMINISTRATOR').then((val) => {
        vm.inUserView = val;
      });


      vm.gridRunning = true;
      if(vm.mode === 'edit') {
        // Get Provider locations..
        DsoUsers.getProviderLocationsById({id: vm.user.id},(locations) => {
          currentLocations(locations);
        },function(error) {
          handleAjaxError(error);
        });
        vm.auditEventsPromise = Users.getAuditEvents({userId: vm.user.userId}).$promise;
      }
      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors(['uniqueEmailAddress','taxId']);
      });
      $scope.$watch('vm.locationSvcUnavailable',function(val) {
        if (val) {
          $scope.dnConfirmationMessage.$show("Tax ID location services are currently unavailable.  Please try again later.",
          'warning');
        }
      });

      vm.currentDsoTaxIdLocationGridOptions = {
        treeRowHeaderAlwaysVisible: false,
        showTreeExpandNoChildren: false,
        columnDefs: [
          {displayName: 'Tax ID', field: 'taxId', width: "15%", grouping: { groupPriority: 0 },
          enableSorting: false, cellFilter: 'groupColumn:row', groupingShowAggregationMenu: false},
          {name: 'Location', width: "65%",
          enableSorting: false,
          cellTemplate: '<span style="font-size: 12px; text-transform: none;"'+
          'ng-show="!row.groupHeader"><b>'+
          '{{row.entity | location}}</b>' +
          '</span>',
          cellFilter: 'groupColumn:row',
          groupingShowAggregationMenu: false},
          {name: 'Remove',
          cellTemplate: '<div style="font-size: 12px; text-transform: none;" align="center" ng-show="!row.groupHeader">'+
          '<a href ng-click="grid.appScope.removeLocation(row)" style="color: red;"><i class="fa fa-times-circle fa-lg" aria-hidden="true" title="Remove"></i></a>'+
          '</>', groupingShowAggregationMenu: false}
        ],
        appScopeProvider: {
          removeLocation : (row) => {
            _.remove(vm.currentDsoTaxIdLocationGridOptions.data, (location) => {
              return row.entity.centerId === location.centerId;
            });
            vm.removedLocation = row.entity;
            vm.locationsChanged = true;
          }
        },
        onRegisterApi: function(api) {
          vm.gridApi = api;
          vm.gridApi.grid.registerDataChangeCallback(function() {
          vm.gridApi.treeBase.expandAllRows();
          });
        }
      };

      function submit() {
        $scope.errorControl.showErrors();
        if ($scope.addDsoUserForm.$valid) {
          vm.saving = true;
          vm.user.taxIds = [];
          vm.providerDsoTaxIdLocations = _.cloneDeep(vm.currentDsoTaxIdLocationGridOptions.data);
          _.forEach(vm.providerDsoTaxIdLocations, function(location) {
            deleteLocationRedundantProperties(location);
            vm.user.taxIds.push(location.taxId);
          });
          vm.user.locations = vm.providerDsoTaxIdLocations;
          if(vm.mode === 'add') {
            if(vm.email) {
              vm.user.unverifiedEmail = vm.email;
            }
            DsoUsers.addDsoProvider(vm.user, (result) => {
              if(result.emailAlreadyInUse) {
                $scope.addDsoUserForm.$setValidity('emailAlreadyInUse', false);
                $scope.errorControl.showErrors();
              } else {
                $scope.errorControl.hideErrors();
                vm.providerDsoTaxIdLocations = [];
              }
              $scope.dnConfirmationMessage &&
              $scope.dnConfirmationMessage.$show("Provider has been successfully added.")
                .then(() => {
                  vm.saving = false;
                  $state.go("dsoAdmin.users");
                });
            }, (error) => {
              vm.saving = false;
              handleAjaxError(error);
            });
          }
          if (vm.mode === 'edit') {
            if(vm.email && vm.user.verifiedEmail != vm.email) {
              vm.user.unverifiedEmail = vm.email;
            }
            DsoUsers.updateUser(vm.user, () => {
              $scope.errorControl.hideErrors();
              $scope.dnConfirmationMessage.$show("Provider " + (vm.user.userId) + " has been successfully updated.");
              vm.saving = false;
            }, (error) => {
              vm.saving = false;
              handleAjaxError(error);
            });
          }
        }
        vm.mode = 'edit';
      }

      function resendRegistrationInvite() {
        if(!$scope.addDsoUserForm.$valid) {
          $scope.errorControl && $scope.errorControl.showErrors();
          return;
        }
        vm.emailResent = false;
        if(vm.mode === 'edit' && vm.user.status && vm.user.status === 'pending') {
          if(vm.email) {
            if (vm.user.unverifiedEmail && vm.email.toLowerCase() == vm.user.unverifiedEmail.toLowerCase()) {
              vm.email = vm.user.unverifiedEmail ;
            }else{
              vm.user.unverifiedEmail = vm.email;
            }
          }
          dsoProviderService.resendRegistrationInvite({id: vm.user.id, unverifiedEmail: vm.user.unverifiedEmail}).then(() => {
            $scope.errorControl.hideErrors();
            vm.emailResent = true;
            $scope.dnConfirmationMessage.$show("The Registration Invite has been sent.");
          },function(error){
            handleAjaxError(error);
          });
        }
      }

      function deleteProvider() {
        vm.deleting = true;
        $uibModal.open({
          controller:['$uibModalInstance', 'user', '$scope', function($uibModalInstance, user, $scope) {
            let self = this;
            self.user = user;
            self.delete = function() {
              $uibModalInstance.close(true);
            };
            self.close = function() {
              $uibModalInstance.dismiss();
            };
            $scope.$on('authenticationChanged', () => {
              $uibModalInstance.dismiss();
            });
          }],
          templateUrl: '/js/admin/confirmDelete.html' + appVersion,
          size: 'sm',
          animation: false,
          controllerAs: 'confirmation',
          resolve: {
            user: () => vm.user
          }
        }).result.then(function(val) {
          if (val) {
            DsoUsers.deleteUser({id: vm.user.id}, function() {
              var msg = "";
              if (vm.user.userId) {
                msg = 'Provider '+ (vm.user.userId ? vm.user.userId : '') +' has been deleted.', 'danger';
              } else {
                msg = 'Provider has been deleted.', 'danger';
              }
              $scope.dnConfirmationMessage &&
              $scope.dnConfirmationMessage.$show(msg)
                .then(() => {
                  vm.deleting = false;
                  $state.go("dsoAdmin.users", {refresh: 'providers'});
                });
            });
          }
        }, angular.noop);
      }

      function currentLocations(locations) {
        if(locations.length) {
          vm.user.locations = locations;
          vm.user.taxIds = _.map(_.unionBy(_.unionBy(vm.user.locations, 'centerId'),'taxId'), 'taxId');
          _.forEach(vm.user.taxIds, (taxId) => {
            dsoProviderService.getTaxIdLocations(taxId).then((result) => {
              if(result.locations && result.locations.length) {
                vm.currentDsoTaxIdLocationGridOptions.data = [];
                _.forEach(vm.user.locations, (currentLocation) => {
                  let matchingLocation = _.find(result.locations, (location) => {
                      return currentLocation.centerId === location.centerId;
                  });
                  if(matchingLocation) {
                    vm.currentDsoTaxIdLocationGridOptions.data.push(matchingLocation);
                  }
                });
              }
            },function(error) {
              handleAjaxError(error);
            });
          });
        }
      }

      function handleAjaxError(error) {
          vm.running = false;
      }

      function deleteLocationRedundantProperties(location) {
        delete location.name;
        delete location.address1;
        delete location.address2;
        delete location.city;
        delete location.state;
        delete location.zip5;
        delete location.zip4;
        delete location.phone;
        delete location.fax;
        delete location.npi;
      }

      function previous() {
        $state.go('dsoAdmin.users', {refresh: 'providers'});
      }

  }]);
})();
